import { LoadingParams } from 'framework/list';

export const CALLBACK_TTL_MINUTES = 10;
export const EMERGENCY_TTL_MS = CALLBACK_TTL_MINUTES * 60 * 1000;

export const INTERRUPTIONS_RESOURCE_URL = '/interruptions';

export const DEFAULT_INTERRUPTIONS_SEARCH_REQUEST: LoadingParams = {
  pageNumber: 0,
  pageSize: 30,
};
